/* @jsxImportSource react */

import { Link } from '@packages/modules/src/Link/Link';

export type Datasheet = {
  url: string;
  name: string;
};

export interface ProductCardV2DatasheetLinkProps {
  datasheet: Datasheet;
  ariaDescribedBy?: string;
}

export const ProductCardV2DatasheetLink = ({
  datasheet,
  ariaDescribedBy,
}: ProductCardV2DatasheetLinkProps) => (
  <Link
    href={datasheet.url}
    openInNewTab
    className="text-size-body-xs text-color-text-dark hover:text-color-grey-dark hyphens-auto underline"
    aria-describedby={ariaDescribedBy}
  >
    {datasheet.name}
  </Link>
);
